import React from 'react';

import { Loading } from 'design-system-web';

import { useLabels } from '../../i18n/useLabels';
import type { RowSpinnerViewModel } from '../../viewmodels/rowTypes';

import styles from './QuestionTable.scss';

type Props = {
  viewModel: RowSpinnerViewModel;
};

export function RowSpinner({ viewModel }: Props) {
  const { formatMessage } = useLabels();

  return (
    <div
      role="status"
      aria-label={formatMessage(viewModel.label)}
      className={styles.spinner}
      data-test={`${viewModel.kind}-${viewModel.subject}-loading`}
    >
      <Loading className={styles.spinnerIcon} />
    </div>
  );
}
